<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="domobject_name" [(ttModel)]="edit.domobject_name"></tt-input>
        <tt-button-save ttText="websitenew_create" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
